module.exports = __webpack_public_path__ + "static/tutorial-slide-5-382cbad97f745e30ea7a377708cedf21.png";